import React, { useMemo, useState } from "react";
import { Bus, IWalkaroundReportList } from "../../../logic/api";
import flex from "../../../styles/flex";
import { IconButton } from "@mui/material";
import { FiAlertTriangle, FiDownload, FiEdit, FiTrash } from "react-icons/fi";
import { FaBus, FaUndo } from "react-icons/fa";
import ConfirmationDialog from "../../../components/notifications/confirmationDialog/ConfirmationDialog";
import WaReportDownloader from "../wa_reports/WaReportDownloader";
import { useDate } from "../../../utility/useDate";
import { useTranslation } from "react-i18next";

export interface IBusListItemProps {
    item: Bus;
    onEdit: () => void;
    onDelete: () => void;
    onRestore: () => void;
}
export const BusListItem: React.FC<IBusListItemProps> = (props) => {
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const handleDeleteConfirmationResult = (result: boolean) => {
        setShowDeleteConfirmation(false);
        if (result) {
            props.onDelete();
        }
    };

    const [show, setShow] = useState(false);
    const dateUtils = useDate();
    const { t } = useTranslation();

    const numberFormat = useMemo(() => Intl.NumberFormat(), [])
    const formatMileage = (m?: number) => m ? numberFormat.format(m) : "";

    const milageInt = parseInt(`${props.item.lastResult?.mileage}`);
    const mileageStr = isNaN(milageInt) ? '0' : formatMileage(milageInt);

    return (
        <div style={
            {
                border: "solid 1px lightgray",
                padding: 10,
                borderRadius: 5,
                marginBottom: 5, opacity: props.item.active == true ? 1 : 0.8
            }
        }>
            <div style={{ ...flex.flexRows, justifyContent: "center", alignItems: "center" }}>
                <div style={{ ...flex.flexAuto, minWidth: 50, textAlign: "center" }}>
                    {((props.item.lastResult?.defectCount ?? 0) > 0 || props.item.isVOR) && (
                        <FiAlertTriangle style={{ color: props.item.isVOR ? "red" : "orange", fontSize: 20 }}></FiAlertTriangle>
                    )}
                    {((props.item.lastResult?.defectCount ?? 0) == 0 && props.item.isVOR != true) && (
                        <FaBus style={{ color: "green", fontSize: 20 }}></FaBus>
                    )}

                </div>

                <div style={flex.flexFill}>

                    <div><b style={{ fontSize: 20 }}>{props.item.reg}</b>  {props.item.active != true && (<small style={{ color: "red" }}><b>{t("walkarounds.deleted")}</b></small>)}</div>
                    <div><b style={{ color: props.item.isVOR == true ? "red" : ((props.item.lastResult?.defectCount ?? 0) > 0 ? "orange" : "green") }}>{props.item.isVOR ? t("walkarounds.vor") : t("walkarounds.INSERVICE")}</b></div>
                </div>
                <div style={flex.flexFill}>
                    <WaReportDownloader
                        callBack={() => {
                            setShow(false);
                        }}
                        reportParams={{} as IWalkaroundReportList}
                        show={show}
                        walkaroundResultIds={props.item.lastResult == null ? [] : [props.item.lastResult?.id ?? 0]}
                    >
                        <small>{t("walkarounds.lastWalkaround")}:</small>
                        <div style={{ height: 8 }}></div>
                        <div style={{ color: "blue", fontWeight: "bold" }}>



                            <div style={flex.flexRows}>
                                <div style={{ width: 30, height: 30, backgroundColor: "green", textAlign: "center", color: "white", fontSize: 18, fontWeight: "bold", }}>
                                    <div style={{ paddingTop: 2 }}>{props.item.lastResult?.noDefectCount ?? 0}</div>
                                </div>
                                <div style={{ width: 4 }}></div>
                                <div style={{ width: 30, height: 30, backgroundColor: "orange", textAlign: "center", color: "white", fontSize: 18, fontWeight: "bold", }}>
                                    <div style={{ paddingTop: 2 }}>{props.item.lastResult?.defectCount ?? 0}</div>
                                </div>
                                <div style={{ width: 4 }}></div>
                                <div style={{ width: 30, height: 30, backgroundColor: "red", textAlign: "center", color: "white", fontSize: 18, fontWeight: "bold", }}>
                                    <div style={{ paddingTop: 2 }}>{props.item.lastResult?.vorCount ?? 0}</div>
                                </div>
                            </div>
                            <div style={{ height: 5 }}></div>
                            <div
                                style={{ borderBottom: "solid 1px blue", display: "inline-block", cursor: "pointer" }}
                                onClick={() => {
                                    setShow(true);
                                }}>
                                <small>
                                    <FiDownload></FiDownload>&nbsp;
                                    <b>
                                        {dateUtils.toFormattedFullDateTimeString(props.item.lastResult?.startTime)}
                                    </b>
                                </small>
                            </div>
                            <div style={{ height: 5 }}></div>
                        </div>
                    </WaReportDownloader>

                </div>

                <div style={flex.flexFill}>
                    <small>{t("walkarounds.lastRecMileage")}:</small>
                    <div><b>{mileageStr.length == 0 ? "-" : mileageStr}</b></div>
                </div>

                <div style={flex.flexFill}>
                    <small>{t("walkarounds.assignedWalkaround")}:</small>
                    <div><b style={{ color: props.item.walkaround == null ? "red" : "unset" }}>{props.item.walkaround?.abbrev ?? t("walkarounds.unassigned")}</b></div>
                </div>




                <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                    <div>
                        <IconButton
                            onClick={() => {
                                props.onEdit();
                            }}>
                            <FiEdit></FiEdit>
                        </IconButton>
                        <div><small>{t("general.edit")}</small></div>
                    </div>
                </div>
                {props.item.active == true && (<div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                    <div>
                        <IconButton
                            onClick={() => {
                                setShowDeleteConfirmation(true);
                            }}>
                            <FiTrash></FiTrash>
                        </IconButton>
                        <div><small>{t("general.delete")}</small></div>
                    </div>
                </div>)}
                {props.item.active == false && (
                    <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                        <div>
                            <IconButton
                                onClick={() => {
                                    props.onRestore();
                                }}>
                                <FaUndo></FaUndo>
                            </IconButton>
                            <div><small>{t("general.restore")}</small></div>
                        </div>
                    </div>
                )}
            </div>
            <ConfirmationDialog title={t("walkarounds.deleteBus")} message={t("walkarounds.deleteBusConfirm")} show={showDeleteConfirmation} onClose={handleDeleteConfirmationResult}></ConfirmationDialog>
        </div>
    );


};
